import "core-js/modules/es.function.name.js";
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { dateFormat } from 'enums';
import { list } from 'styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PartnerDetails = function PartnerDetails(_ref) {
  var _partner$name, _partner$address, _partner$eik, _partner$mol, _partner$mol_type, _partner$phone, _partner$email, _partner$fax, _partner$home_visit_f;

  var partner = _ref.partner;
  return ___EmotionJSX("div", {
    css: list
  }, ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0418\u043C\u0435"), ___EmotionJSX("p", {
    className: "value"
  }, (_partner$name = partner === null || partner === void 0 ? void 0 : partner.name) !== null && _partner$name !== void 0 ? _partner$name : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0410\u0434\u0440\u0435\u0441"), ___EmotionJSX("p", {
    className: "value"
  }, (_partner$address = partner === null || partner === void 0 ? void 0 : partner.address) !== null && _partner$address !== void 0 ? _partner$address : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0415\u0418\u041A"), ___EmotionJSX("p", {
    className: "value"
  }, (_partner$eik = partner === null || partner === void 0 ? void 0 : partner.eik) !== null && _partner$eik !== void 0 ? _partner$eik : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041C\u041E\u041B"), ___EmotionJSX("p", {
    className: "value"
  }, (_partner$mol = partner === null || partner === void 0 ? void 0 : partner.mol) !== null && _partner$mol !== void 0 ? _partner$mol : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0422\u0438\u043F \u043D\u0430 \u041C\u041E\u041B"), ___EmotionJSX("p", {
    className: "value"
  }, (_partner$mol_type = partner === null || partner === void 0 ? void 0 : partner.mol_type) !== null && _partner$mol_type !== void 0 ? _partner$mol_type : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"), ___EmotionJSX("p", {
    className: "value"
  }, (_partner$phone = partner === null || partner === void 0 ? void 0 : partner.phone) !== null && _partner$phone !== void 0 ? _partner$phone : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0418\u043C\u0435\u0439\u043B"), ___EmotionJSX("p", {
    className: "value"
  }, (_partner$email = partner === null || partner === void 0 ? void 0 : partner.email) !== null && _partner$email !== void 0 ? _partner$email : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0424\u0430\u043A\u0441"), ___EmotionJSX("p", {
    className: "value"
  }, (_partner$fax = partner === null || partner === void 0 ? void 0 : partner.fax) !== null && _partner$fax !== void 0 ? _partner$fax : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041A\u043E\u043C\u0438\u0441\u0438\u043E\u043D\u043D\u0430 (%)"), ___EmotionJSX("p", {
    className: "value"
  }, (_partner$home_visit_f = partner === null || partner === void 0 ? void 0 : partner.home_visit_fee_commission_percent) !== null && _partner$home_visit_f !== void 0 ? _partner$home_visit_f : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u044A\u0437\u0434\u0430\u0434\u0435\u043D \u043D\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, moment(partner === null || partner === void 0 ? void 0 : partner.created_at).isValid() ? moment(partner === null || partner === void 0 ? void 0 : partner.created_at).format(dateFormat) : 'N/A')));
};

PartnerDetails.propTypes = {
  partner: PropTypes.object
};
export default PartnerDetails;